<template>
  <section class="confirm-information">
    <v-dialog
      v-model="dialog"
      width="500px">
      <div class="dialog-container">
        <p>Are you sure you want to change <br /> the following information?</p>
        <p>Your account information will be updated at <br /> the same time</p>
        <p
          v-for="(item, index) in upd_def_info"
          :key="index">
          {{ item.name }}
        </p>
        <div>
          <v-button
            type="primary"
            @click="handlerConfirm(true)">Confirm</v-button>
          <v-button @click="handlerConfirm(false)">Not Now</v-button>
        </div>
      </div>
    </v-dialog>
  </section>
</template>
<script>
export default {
  name: 'ConfirmInformationDialog',
  props: {
    upd_def_info: {
      type: [Array, Object],
      default: () => ([])
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerConfirm(result) {
      this.dialog = false
      this.$emit('confirm', result)
    },
  }
}
</script>
<style lang="scss" scoped>
.confirm-information {
    .dialog-container {
        padding: 20px 15px;
        text-align: center;
        p {
            padding-bottom: 15px;
        }
        p:first-child {
            font-weight: 500;
        }
    }
}
</style>